import { SchemaWidgetInstance } from "../SchemaWidgetClass";

export const contactPointJson = (data: SchemaWidgetInstance, page: any) => {
  const contactPointJsonLd = {
    "@context": "https://schema.org",
    "@type": "ContactPoint",
    name:
      data.get("name") ||
      [page?.get("firstName"), page?.get("lastName")]
        .filter(Boolean)
        .join(" ") ||
      null,
    description: data.get("description") || page?.get("description") || null,
    areaServed: data.get("areaServed") || page?.get("areaServed") || null,
    availableLanguage:
      data.get("availableLanguage") || page?.get("availableLanguage") || null,
    contactType: data.get("contactType") || page?.get("contactType") || null,
    email: data.get("email") || page?.get("email") || null,
    hoursAvailable:
      data.get("hoursAvailable") || page?.get("hoursAvailable") || null,
    telephone:
      data.get("telephone") ||
      page?.get("altPhoneNumber") ||
      page?.get("phoneNumber") ||
      null,
  };

  return contactPointJsonLd;
};
